<script>
  import { page } from '@inertiajs/svelte';

  export let admin;
</script>

<div class="admin-bar">
  <ul class="admin-bar__menu">
    <li class="admin-bar__menu-item">
      <a class="admin-bar__menu-link" href={admin.dashboard}>
        <img
          src={`${$page.props.asset_url}/img/admin/wordpress-logo.svg`}
          width="24"
          height="24"
          alt="Wordpress logo"
        />
      </a>
    </li>
    <li class="admin-bar__menu-item">
      <a class="admin-bar__menu-link" href={admin.edit}>
        <img
          src={`${$page.props.asset_url}/img/admin/edit.svg`}
          width="18"
          height="18"
          alt="Edit"
        />
        <span>Edit</span>
      </a>
    </li>
  </ul>
</div>

<style lang="scss">
  .admin-bar {
    position: fixed;
    z-index: 99999;
    top: 0;
    left: 0;
    right: 0;

    padding: 0 0.5rem;

    color: white;
    background-color: black;

    &__menu {
      display: flex;
      // align-items: center;
      gap: 1rem;

      font-size: 1.4rem;

      &-link {
        display: flex;
        align-items: center;
        gap: 0.75rem;

        height: 100%;
        padding: 0.7rem;

        &:hover {
          background-color: rgba(white, 0.2);
        }
      }
    }
  }
</style>
